import utils from '@eitje/utils'
import pluralize from 'pluralize'
import {config} from '../config'

const irregularPluralKinds = {
	omzetGroep: 'omzetGroepen',
	omzetGroepen: 'omzetGroepen',
}

const irregularSingularKinds = {
	omzetGroepen: 'omzetGroep',
}

export const normalizeKind = kind => {
	if (!kind) return kind
	const camelKind = utils.snakeToCamel(kind)
	return irregularPluralKinds[camelKind] || pluralize.plural(camelKind)
}

export const normalizeJoinKeys = joins => {
	if (!joins) return []
	const joinKeys = Array.isArray(joins) ? joins : [joins]
	return joinKeys.map(normalizeKind).uniq()
}

const singularKind = kind => {
	const normalizedKind = normalizeKind(kind)
	return irregularSingularKinds[normalizedKind] || pluralize.singular(normalizedKind)
}

export const backendKind = kind => (kind ? utils.camelToSnake(normalizeKind(kind)) : kind)

export const backendSingularKind = kind => (kind ? utils.camelToSnake(singularKind(kind)) : kind)

export const isMultipleRelation = (parentKind, joinKind) => {
	const parentConfig = config.dbConfig?.[singularKind(parentKind)]
	return parentConfig?.hasMany?.includes(singularKind(joinKind))
}

export const getBidirectionalRelationKinds = kind => {
	const sourceKind = singularKind(kind)
	const configuredRelations = config.dbConfig[sourceKind]?.bidirectionalRelations || []
	const inverseRelations = Object.keys(config.dbConfig).filter(relationKind =>
		config.dbConfig[relationKind].bidirectionalRelations?.includes(sourceKind),
	)
	return [...configuredRelations, ...inverseRelations].map(normalizeKind)
}

export const getAssociationKey = (parentKind, joinKind) => {
	return isMultipleRelation(parentKind, joinKind) ? joinKind : singularKind(joinKind)
}
